import { i18n } from '@/utils/i18n';

export const columns = {
    id: {
        show: true,
        title: "№",
        sortable: true,
        column: 'id'
    },
    address: {
        show: true,
        title: i18n.t('message.address'),
        sortable: true,
        column: 'address'
    },
    web_site: {
        show: true,
        title: i18n.t('message.web_site'),
        sortable: true,
        column: 'web_site'
    },
    footer_image: {
        show: true,
        title: i18n.t('message.footer_image'),
        sortable: true,
        column: 'footer_image'
    },
    full_logo: {
        show: true,
        title: i18n.t('message.full_logo'),
        sortable: true,
        column: 'full_logo'
    },
    half_logo: {
        show: true,
        title: i18n.t('message.half_logo'),
        sortable: true,
        column: 'half_logo'
    },
    phone_number: {
        show: true,
        title: i18n.t('message.phone_number'),
        sortable: true,
        column: 'phone_number'
    },

    email: {
        show: false,
        title: i18n.t('message.email'),
        sortable: true,
        column: 'email'
    },
    image: {
        show: false,
        title: i18n.t('message.logo'),
        sortable: true,
        column: 'image'
    },
};